module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTIS2yoS2yoS2yoS2yoS2yoS2yoS2yoS2yoS2yutKRjoAAAAJdFJOUwBJ8NFxxiGhEPwafooAAAAJcEhZcwAAAEgAAABIAEbJaz4AAACQSURBVBjTY2BgCZoJBqoODAxsljOhYHICA/NMODBg8ERwpjBEgqjplSByKgNEAUQxhCPAiOBMZmCwhHEmGTIwCGtCOGUNDEDAkQ7mCDCAASOYowjhCIE5k8BSjJoQA8BSklDTpoA4nlDORGSZaSBOJpSjwCAayMAE5WgA7StrAhoL8QIETEX1HIq3UQIEOagA+4d6MSQWjhEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/school/211.png
// module id = 215
// module chunks = 0